export function getCategoryUrl({ name, tags }: { name: string; tags?: string[] }) {
  if (tags?.map((category: string) => category.toLocaleLowerCase())?.includes('category')) {
    return `/categories/${name}`;
  }
  return `/${name}`;
}
